"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonToUSFM = void 0;

var USFM = _interopRequireWildcard(require("./USFM"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable brace-style */

/**
 * @description for converting from json format to USFM.  Main method is jsonToUSFM()
 */
var params_ = {};
var wordMap_ = {};
var wordIgnore_ = [];
var milestoneMap_ = {};
var milestoneIgnore_ = [];
/**
 * @description checks if we need to add a newline if next object is not text or newline
 * @param {Object} nextObject - next object to be output
 * @return {String} either newline or empty string
 */

var needsNewLine = function needsNewLine(nextObject) {
  var retVal = '';

  if (nextObject && nextObject.tag === 'zaln') {
    retVal = '\n'; // prevent cramming of alignments together
  }

  return retVal;
};
/**
 * @description test if last character was newline (or return) char
 * @param {String} line - line to test
 * @return {boolean} true if newline
 */


var isLastCharNewLine = function isLastCharNewLine(line) {
  var lastChar = line ? line.substr(line.length - 1) : '';
  return lastChar === '\n';
};
/**
 * @description Takes in word json and outputs it as USFM.
 * @param {Object} wordObject - word in JSON
 * @param {Object} nextObject - next object to be output
 * @return {String} - word in USFM
 */


var generateWord = function generateWord(wordObject, nextObject) {
  var keys = Object.keys(wordObject);
  var attributes = [];
  var word = wordObject.text;

  for (var i = 0, len = keys.length; i < len; i++) {
    var key = keys[i];

    if (!wordIgnore_.includes(key)) {
      var value = wordObject[key];

      if (wordMap_[key]) {
        // see if we should convert this key
        key = wordMap_[key];
      }

      var prefix = '';

      if (USFM.wordSpecialAttributes.includes(key)) {
        prefix = 'x-';
      }

      var attribute = prefix + key;

      if (value) {
        // add value only if set
        attribute += '="' + value + '"';
      }

      attributes.push(attribute);
    }
  }

  var attrOut = attributes.join(' ');

  if (attrOut) {
    attrOut = '|' + attrOut;
  }

  var line = '\\w ' + word + attrOut + '\\w*';
  return line;
};
/**
 * @description Takes in word json and outputs it as USFM.
 * @param {Object} phraseObject - word in JSON
 * @param {Object} nextObject - next object to be output
 * @return {String} - word in USFM
 */


var generatePhrase = function generatePhrase(phraseObject, nextObject) {
  var tag = phraseObject.tag || 'zaln';
  var markerTermination = '';

  if (typeof phraseObject.endTag === 'string') {
    markerTermination = phraseObject.endTag; // new format takes precidence

    delete phraseObject.endTag;
  } else {
    markerTermination = tag + '-e\\*'; // fall back to old generation method
  }

  var content = '';
  var milestoneType = phraseObject.type === 'milestone';

  if (milestoneType) {
    var keys = Object.keys(phraseObject);
    var attributes = [];

    for (var i = 0, len = keys.length; i < len; i++) {
      var key = keys[i];

      if (!milestoneIgnore_.includes(key)) {
        var value = phraseObject[key];

        if (milestoneMap_[key]) {
          // see if we should convert this key
          key = milestoneMap_[key];
        }

        var prefix = 'x-';
        var attribute = prefix + key + '="' + value + '"';
        attributes.push(attribute);
      }
    }

    content = '-s | ' + attributes.join(' ') + '\\*';
  } else {
    var isUsfm3Milestone = USFM.markerIsMilestone(tag);

    if (isUsfm3Milestone) {
      if (phraseObject.attrib) {
        content = phraseObject.attrib;
      }

      content += "\\*";
    }

    if (phraseObject.text) {
      content += ' ' + phraseObject.text;
    }

    if (phraseObject.content) {
      content += ' ' + phraseObject.content;
    }
  }

  var line = '\\' + tag + content;
  /* eslint-disable no-use-before-define */

  line = objectToString(phraseObject.children, line);
  /* eslint-enable no-use-before-define */

  if (markerTermination) {
    line += '\\' + markerTermination + (phraseObject.nextChar || needsNewLine(nextObject));
  }

  return line;
};
/**
 * @description convert usfm marker to string
 * @param {object} usfmObject - usfm object to output
 * @param {object} nextObject - usfm object that will come next
 * @param {Boolean} noSpaceAfterTag - if true then do not put space after tag
 * @param {Boolean} noTermination - if true then do not add missing termination
 * @return {String} Text equivalent of marker.
 */


var usfmMarkerToString = function usfmMarkerToString(usfmObject) {
  var nextObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var noSpaceAfterTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var noTermination = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var output = "";
  var content = usfmObject.text || usfmObject.content || "";
  var markerTermination = usfmObject.endTag; // new format takes precidence

  if (typeof markerTermination !== 'string' && USFM.markerTermination(usfmObject.tag) && !noTermination) {
    markerTermination = usfmObject.tag + '*'; // fall back to old generation method
  }

  if (usfmObject.tag) {
    output = '\\' + usfmObject.tag;

    if (usfmObject.number) {
      output += ' ' + usfmObject.number;
    }

    var firstChar = content.substr(0, 1);

    if (noSpaceAfterTag) {// no spacing
    } else if (usfmObject.attrib) {
      if (content) {
        output += ' ' + content;
      }

      if (usfmObject.tag.substr(-2) === '\\*') {
        // we need to apply attibute before \*
        output = output.substr(0, output.length - 2) + usfmObject.attrib + output.substr(-2);
      } else {
        output += usfmObject.attrib;
      }

      content = '';
    } else if (!markerTermination) {
      if (firstChar !== '' && firstChar !== '\n' && content !== ' \n') {
        // make sure some whitespace
        output += ' ';
      } else if (nextObject && usfmObject.tag && !content && // make sure some whitespace
      !usfmObject.nextChar && !['w', 'k', 'zaln'].includes(nextObject.tag)) {
        output += ' ';
      }
    } else if (firstChar !== ' ') {
      // if marker termination, make sure we have space
      output += ' ';
    }
  }

  if (content) {
    output += content;
  }

  if (markerTermination) {
    output += '\\' + markerTermination;
  }

  if (usfmObject.nextChar) {
    output += usfmObject.nextChar;
  }

  return output;
};
/**
 * determines if we are currently on a displayable line
 * @param {String} output - previous output
 * @return {boolean}
 */


var isOnDisplayableLine = function isOnDisplayableLine(output) {
  var isDisplayableLine = false;
  var pos = output.lastIndexOf('\\');

  if (pos >= 0) {
    var endSegment = output.substr(pos + 1);
    var parts = endSegment.split(' ');

    if (parts.length === 2 && parts[1] === '') {
      isDisplayableLine = USFM.markerDisplayable(parts[0]);
    }
  }

  return isDisplayableLine;
};
/**
 * @description adds word to the line and makes sure it has appropriate spacing
 * @param {String} text - to add
 * @param {String} output - string to add to
 * @return {String} updated output
 */


var addPhrase = function addPhrase(text, output) {
  var prefixNewLine = false;
  output = output || "";

  if (text) {
    prefixNewLine = false;
    var lastChar = output ? output.substr(output.length - 1) : '';

    if (params_.forcedNewLines) {
      if (lastChar === ' ') {
        if (!isOnDisplayableLine(output)) {
          output = output.substr(0, output.length - 1); // trim space

          prefixNewLine = true;
        }
      }
    }

    if (prefixNewLine) {
      text = '\n' + text;
    }

    output += text;
  }

  return output;
};
/**
 * @description converts object to string and appends to line
 * @param {string|array|object} object - marker to print
 * @param {string} output - marker to print
 * @param {String|array|object} nextObject - optional object that is next entry.  Used to determine if we need to
 *                                add a space between current marker and following text
 * @return {String} Text equivalent of marker appended to output.
 */


var objectToString = function objectToString(object, output) {
  var nextObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!object) {
    return "";
  }

  output = output || "";

  if (object.verseObjects) {
    // support new verse object format
    object = object.verseObjects;
  }

  if (Array.isArray(object)) {
    var _nextObject;

    for (var i = 0, len = object.length; i < len; i++) {
      var objectN = _nextObject ? _nextObject : object[i];
      _nextObject = i + 1 < object.length ? object[i + 1] : null;
      output = objectToString(objectN, output, _nextObject);
    }

    return output;
  }

  if (object.type === 'text') {
    return output + object.text;
  }

  if (object.type === 'word') {
    // usfm word marker
    return addPhrase(generateWord(object, nextObject), output);
  }

  if (object.type === 'milestone' && object.endTag !== object.tag + '*') {
    // milestone type (phrase)
    return addPhrase(generatePhrase(object, nextObject), output);
  } else if (object.children && object.children.length) {
    return output + generatePhrase(object, nextObject);
  }

  if (object.tag) {
    // any other USFM marker tag
    return output + usfmMarkerToString(object, nextObject);
  }

  return output;
};
/**
 * @description Takes in verse json and outputs it as a USFM line array.
 * @param {String} verseNumber - number to use for the verse
 * @param {Array|Object} verseObjects - verse in JSON
 * @return {String} - verse in USFM
 */


var generateVerse = function generateVerse(verseNumber, verseObjects) {
  var verseText = objectToString(verseObjects);
  var object = {
    tag: 'v',
    number: verseNumber,
    text: verseText
  };
  return usfmMarkerToString(object);
};
/**
 * @description adds verse to lines array, makes sure there is a newline before verse
 * @param {Array} lines - array to add to
 * @param {String} verse - line to add
 * @return {Array} updated lines array
 */


var addVerse = function addVerse(lines, verse) {
  if (params_.forcedNewLines && lines && lines.length) {
    var lastLine = lines[lines.length - 1];

    if (!isLastCharNewLine(lastLine)) {
      // need to add newline
      var quoted = lastLine.indexOf('\n\\q') >= 0;

      if (!quoted) {
        // don't add newline before verse if quoted
        verse = '\n' + verse;
      }
    }
  }

  lines = lines.concat(verse);
  return lines;
};
/**
 * @description adds chapter to lines array, makes sure there is a newline before chapters
 * @param {Array} lines - array to add to
 * @param {Array} chapter - chapter lines to add
 * @return {Array} updated lines array
 */


var addChapter = function addChapter(lines, chapter) {
  if (lines && lines.length) {
    var lastLine = lines[lines.length - 1];

    if (!isLastCharNewLine(lastLine)) {
      // need to add newline
      if (chapter && chapter.length) {
        chapter[0] = '\n' + chapter[0]; // add newline to start of chapter
      }
    }
  }

  lines = lines.concat(chapter);
  return lines;
};
/**
 * get sorted list of verses. `front` will be first, the rest sorted alphabetically
 * @param {Array} verses - to sort
 * @return {string[]} sorted verses
 */


var sortVerses = function sortVerses(verses) {
  var sortedVerses = verses.sort(function (a, b) {
    var delta = parseInt(a, 10) - parseInt(b, 10);

    if (delta === 0) {
      // handle verse spans, unspanned verse first
      delta = a > b ? 1 : -1;
    }

    return delta;
  });
  return sortedVerses;
};
/**
 * @description Takes in chapter json and outputs it as a USFM line array.
 * @param {String} chapterNumber - number to use for the chapter
 * @param {Object} chapterObject - chapter in JSON
 * @return {Array} - chapter in USFM lines/string
 */


var generateChapterLines = function generateChapterLines(chapterNumber, chapterObject) {
  var lines = [];
  lines.push('\\c ' + chapterNumber + '\n');

  if (chapterObject.front) {
    // handle front matter first
    var verseText = objectToString(chapterObject.front);
    lines = lines.concat(verseText);
    delete chapterObject.front;
  }

  var verseNumbers = sortVerses(Object.keys(chapterObject));
  var verseLen = verseNumbers.length;

  for (var i = 0; i < verseLen; i++) {
    var verseNumber = verseNumbers[i]; // check if verse is inside previous line (such as \q)

    var lastLine = lines.length ? lines[lines.length - 1] : "";
    var lastChar = lastLine ? lastLine.substr(lastLine.length - 1) : "";

    if (lastChar && lastChar !== '\n' && lastChar !== ' ') {
      // do we need white space
      lines[lines.length - 1] = lastLine + ' ';
    }

    var verseObjects = chapterObject[verseNumber];
    var verseLine = generateVerse(verseNumber, verseObjects);
    lines = addVerse(lines, verseLine);
  }

  return lines;
};
/**
 * @description convert object to text and add to array.  Objects are terminated with newline
 * @param {array} output - array where text is appended
 * @param {Object} usfmObject - USFM object to convert to string
 */


var outputHeaderObject = function outputHeaderObject(output, usfmObject) {
  var noSpace = false;

  if (usfmObject.content) {
    var firstChar = usfmObject.content.substr(0, 1);
    noSpace = ['-', '*'].includes(firstChar) || usfmObject.content.substr(0, 2) === '\\*';
  }

  var text = usfmMarkerToString(usfmObject, null, noSpace, true);

  if (usfmObject.type === 'text' && typeof usfmObject.text === 'string') {
    text += '\n';
  } else if (usfmObject.tag) {
    text += '\n';
  }

  output.push(text);
};
/**
 * @description Goes through parameters and populates ignore lists and parameter maps
 *                for words and milestones
 */


var processParams = function processParams() {
  wordMap_ = params_.map ? params_.map : {};
  wordMap_.strongs = 'strong';
  wordIgnore_ = ['text', 'tag', 'type'];

  if (params_.ignore) {
    wordIgnore_ = wordIgnore_.concat(params_.ignore);
  }

  milestoneMap_ = params_.mileStoneMap ? params_.mileStoneMap : {};
  milestoneMap_.strongs = 'strong';
  milestoneIgnore_ = ['children', 'tag', 'type'];

  if (params_.mileStoneIgnore) {
    milestoneIgnore_ = milestoneIgnore_.concat(params_.mileStoneIgnore);
  }
};
/**
 * @description Takes in scripture json and outputs it as a USFM string.
 * @param {Object} json - Scripture in JSON
 * @param {Object} params - optional parameters like attributes to ignore.  Properties:
 *                    chunk {boolean} - if true then output is just a small piece of book
 *                    ignore (Array} - list of attributes to ignore on word objects
 *                    map {Object} - dictionary of attribute names to map to new name on word objects
 *                    mileStoneIgnore (Array} - list of attributes to ignore on milestone objects
 *                    mileStoneMap {Object} - dictionary of attribute names to map to new name on milestone objects
 *                    forcedNewLines (boolean} - if true then we add newlines before alignment tags, verses, words
 * @return {String} - Scripture in USFM
 */


var jsonToUSFM = function jsonToUSFM(json, params) {
  params_ = params || {}; // save current parameters

  processParams();
  var output = [];

  if (json.headers) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = json.headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var header = _step.value;
        outputHeaderObject(output, header);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  if (json.chapters) {
    var chapterNumbers = Object.keys(json.chapters);
    var chapterLen = chapterNumbers.length;

    for (var i = 0; i < chapterLen; i++) {
      var chapterNumber = chapterNumbers[i];
      var chapterObject = json.chapters[chapterNumber];
      var chapterLines = generateChapterLines(chapterNumber, chapterObject);
      output = addChapter(output, chapterLines);
    }
  }

  if (json.verses) {
    var verseNumbers = sortVerses(Object.keys(json.verses));
    var verseLen = verseNumbers.length;

    for (var _i = 0; _i < verseLen; _i++) {
      var verseNumber = verseNumbers[_i];
      var verseObjects = json.verses[verseNumber];
      var verse = generateVerse(verseNumber, verseObjects);
      output = addVerse(output, verse);
    }
  }

  return output.join('');
};

exports.jsonToUSFM = jsonToUSFM;